// Trades per page on the /sending and /receiving tab lists
export const TRADES_PAGE_SIZE = 25;

// Desktop height of the black panel block on /sending and /receiving (title row
// included; the map runs underneath it). Fixed so a tab switch never moves the
// trade list under the cursor; auto under 768px. 480 per the round-1 design
// review, superseding the 300 the ticket sized for a side-by-side layout.
export const TRADE_PANEL_HEIGHT = 480;

// localStorage key for the panel's collapsed flag; suffixed per user
export const TRADE_PANEL_COLLAPSED_KEY = 'tradePanelCollapsed';

// localStorage key for the map's "Show inbound / Show outbound" context layer; suffixed per user
export const TRADE_MAP_CONTEXT_KEY = 'tradeMapContext';
